import { useField } from "formik";
import { isObject } from "lodash";
import { HTMLProps, useMemo, useRef } from "react";
import styled from "styled-components";

import { useFieldName } from "./forms";
import getThumbnailUrl from "../utils/getThumbnailUrl";

const PictureInputStyled = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50px;
  overflow: hidden;
  background: yellow;
  position: relative;
  margin: 0 auto;

  input {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 2;
    display: block;
    opacity: 0;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    object-fit: cover;
    width: 100%;
    height: 100%;
    &:not([src]) {
      background-image: url("data:image/svg+xml,%3Csvg width='35' height='31' viewBox='0 0 35 31' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.5 24.1599C19.433 24.1599 21.0656 23.5003 22.398 22.1811C23.7303 20.8619 24.3965 19.2358 24.3965 17.3028C24.3965 15.3435 23.7303 13.7043 22.398 12.3851C21.0656 11.0653 19.433 10.4054 17.5 10.4054C15.5406 10.4054 13.9014 11.0653 12.5822 12.3851C11.263 13.7043 10.6035 15.3435 10.6035 17.3028C10.6035 19.2358 11.263 20.8619 12.5822 22.1811C13.9014 23.5003 15.5406 24.1599 17.5 24.1599ZM0.924072 30.5476V4.01861H9.66298L12.7976 0.374268H22.2418L25.3765 4.01861H34.0759V30.5476H0.924072Z' fill='white'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-color: #9ea5b6;
      background-position: center center;
    }
  }
`;

const PictureInput = ({ ...props }: HTMLProps<HTMLInputElement>) => {
  const name = useFieldName();
  const [field, _, { setValue }] = useField<
    File | string | { url: string } | undefined
  >(name);
  const imgRef = useRef<HTMLImageElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const imgUrl = useMemo(() => {
    if (field.value instanceof File) {
      return URL.createObjectURL(field.value);
    } else if (isObject(field.value) && "url" in field.value) {
      return getThumbnailUrl(field.value.url);
    } else if (field.value) {
      return getThumbnailUrl(field.value);
    }
    return undefined;
  }, [field.value]);
  return (
    <div>
      <PictureInputStyled>
        <input
          ref={inputRef}
          id={field.name}
          name={field.name}
          type="file"
          onChange={(e) => {
            setValue(e.target.files?.[0]);
          }}
          accept="image/*"
          value={undefined}
          {...props}
        />
        <img ref={imgRef} src={imgUrl} />
      </PictureInputStyled>
      <div
        className="small text-primary fw-bold text-center mt-1"
        onClick={(e) => {
          e.preventDefault();
          inputRef.current?.click();
        }}
      >
        {!field.value ? "Add" : "Edit"} profile picture
      </div>
    </div>
  );
};

export default PictureInput;
